import {action, computed, makeObservable, observable, runInAction} from "mobx";
import Feature from "../Feature";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";

export default class ChatWidgetFeature extends Feature{

    constructor(application) {
        super(application);
        this._isOpen = false;
        this._isTyping = false;
        this._draft = "";
        this._nextMessageId = 1;
        this._messages = [
            this._createMessage("assistant", "Hola, soy el SDP Chatbot."),
            this._createMessage("assistant", "Consultame cualquier duda sobre funcionalidades y procesos del portal."),
        ];

        makeObservable(this, {
            _isOpen: observable,
            _isTyping: observable,
            _draft: observable,
            _messages: observable,
            isOpen: computed,
            isTyping: computed,
            draft: computed,
            messages: computed,
            toggleOpen: action,
            open: action,
            close: action,
            updateDraft: action,
            sendMessage: action,
            _appendMessage: action,
        });
    }

    load() {
        this.finishLoading();
    }

    get isOpen() {
        return this._isOpen;
    }

    get isTyping() {
        return this._isTyping;
    }

    get draft() {
        return this._draft;
    }

    get messages() {
        return this._messages;
    }

    toggleOpen() {
        this._isOpen = !this._isOpen;
    }

    open() {
        this._isOpen = true;
    }

    close() {
        this._isOpen = false;
    }

    updateDraft(value) {
        this._draft = value;
    }

    async sendMessage() {
        const message = this._draft.trim();
        if (!message) {
            return false;
        }
        this._appendMessage({
            author: "user",
            content: message,
        });
        this._draft = "";

        const history = this._historyPayload();
        this._isTyping = true;

        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                runInAction(() => {
                    this._isTyping = false;
                    this._appendMessage({
                        author: "assistant",
                        content: response.answer(),
                    });
                });
            },
            handlesError: () => {
                runInAction(() => {
                    this._isTyping = false;
                    this._appendMessage({
                        author: "assistant",
                        content: "Tuve un problema al consultar el SDP Chatbot. Probá de nuevo en unos minutos.",
                    });
                });
            }
        });

        try {
            await this._application.apiClient().askBackofficeAssistant(
                message,
                history,
                responseHandler
            );
        } catch (error) {
            runInAction(() => {
                this._isTyping = false;
                this._appendMessage({
                    author: "assistant",
                    content: "Tuve un problema al consultar el SDP Chatbot. Probá de nuevo en unos minutos.",
                });
            });
        }

        return true;
    }

    _appendMessage(message) {
        this._messages.push(this._createMessage(message.author, message.content));
    }

    _createMessage(author, content) {
        return {
            id: this._nextMessageId++,
            author: author,
            content: content,
            createdAt: new Date(),
        };
    }

    _historyPayload() {
        const allMessages = this._messages.map((message) => ({
            role: message.author === "user" ? "user" : "assistant",
            content: message.content,
        }));
        return allMessages.slice(-5);
    }
}
